package io.github.jangalinski.pages._2016._09._15

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initAndTheWinnerIsPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("2016/09/15/AndTheWinnerIs.md", FrontMatterElement.Builder { addScalar("title", "Camunda Community Award 2016"); addScalar("subtitle", "and the winner is .... me :-)"); addScalar("date", "2016-09-15"); }))
}

@Page("/2016/09/15/and-the-winner-is")
@Layout(".site.components.layout.BlogLayout")
@Composable
fun AndTheWinnerIsPage() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("It's been a few days, but nonetheless ... time to show-off:")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/img/2016-09-15-camunda-community-award.png", "Camunda Community Award")
    }
}
